import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import {
    clearChunkReloadGuard,
    initChunkLoadRecoveryListeners,
    stripChunkReloadQueryParam,
} from 'app/core/pwa/chunk-load-recovery';
import { capturePwaInstallPromptEarly } from 'app/core/pwa/pwa-install.prompt';
import { stripHardReloadQueryParam } from 'app/core/pwa/pwa-update.service';

function shouldBlockNumberInputWheel(event: WheelEvent): boolean {
    const target = event.target as HTMLElement | null;
    if (!target) return false;

    const input = target.closest('input[type="number"]') as HTMLInputElement | null;
    if (!input) return false;

    // Block wheel increments/decrements when the number input is active.
    return document.activeElement === input;
}

if (typeof window !== 'undefined') {
    capturePwaInstallPromptEarly();
    stripHardReloadQueryParam();
    stripChunkReloadQueryParam();
    initChunkLoadRecoveryListeners();

    // Global ApexCharts defaults: disable entrance/update animations so dashboard
    // charts render instantly instead of animating on every load/theme refresh,
    // which was compounding with scroll to cause jank on dashboard pages.
    (window as any).Apex = {
        ...(window as any).Apex,
        chart: {
            ...((window as any).Apex && (window as any).Apex.chart),
            animations: { enabled: false },
        },
    };

    window.addEventListener(
        'wheel',
        (event) => {
            if (!shouldBlockNumberInputWheel(event)) return;
            event.preventDefault();
        },
        { passive: false, capture: true },
    );
}

bootstrapApplication(AppComponent, appConfig)
    .then(() => {
        clearChunkReloadGuard();
    })
    .catch((err) => console.error(err));
